interface Props {
  value: string;
  onChange: any;
  placeholder: any;
  type?: 'text' | 'number' | 'tel' | 'email';
  size?: 'base' | 'small';
}

export function TextInput({ placeholder, onChange, value, type = 'text', size }: Props) {
  const padding = size === 'base' ? 'px-4 py-3' : size === 'small' ? 'p-2' : 'px-4 py-3';

  return (
    <input
      tabIndex={0}
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={`w-full ${padding} text-sm outline-none border-2 border-grey3 rounded-lg focus:border-neutralBlue1 focus:shadow-[0px_0px_0px_2px_rgb(182,207,255,0.25)]`}
    />
  );
}
